<template>
  <app-layout>
    <div class="sc-container">
      <div class="page-wrap">

        <!-- Sidebar -->
        <aside class="page-sidebar">
          <div class="sidebar-card">
            <div class="sidebar-profile">
              <img
                v-if="user.avatar"
                class="sidebar-avatar"
                :src="$avatarSrc(user.avatar, 'users')"
                alt="User avatar"
              />
              <img
                v-else
                class="sidebar-avatar"
                src="/assets/avatar.png"
                alt="User avatar"
              />
              <div class="sidebar-name">{{ user.fname }} {{ user.lname }}</div>
              <div class="sidebar-sub" v-if="user.currentcompany">
                {{ user.current_position }} &mdash; {{ user.currentcompany.name }}
              </div>
              <div class="sidebar-sub" v-else>{{ user.profession }}</div>
            </div>
            <nav class="sidebar-nav">
              <router-link class="sidebar-link" to="/profile/update">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                Edit Profile
              </router-link>
              <router-link class="sidebar-link" to="/profile/change-password">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                Change Password
              </router-link>
              <router-link class="sidebar-link" to="/notification-settings">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
                Notification Settings
              </router-link>
              <router-link class="sidebar-link" to="/my-Projects">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 20h20M4 20V10l8-6 8 6v10"/></svg>
                My Projects
              </router-link>
              <router-link class="sidebar-link" to="/my-followers">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                Following
              </router-link>
              <router-link class="sidebar-link" to="/my-blog-history">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                My Blog
              </router-link>
              <router-link class="sidebar-link" to="/my-service-requests">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"/></svg>
                Service Requests
              </router-link>
            </nav>
          </div>
        </aside>

        <!-- Main content -->
        <main class="page-main">
          <div class="main-card">
            <div class="main-card-header">
              <h2 class="main-card-title">Work Experience</h2>
              <p class="main-card-subtitle">Add and manage your professional work history.</p>
            </div>

            <div class="main-card-body">
              <!-- Coming soon banner -->
              <div class="info-banner">
                <div class="info-banner-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                </div>
                <div class="info-banner-body">
                  <div class="info-banner-title">Experience section coming soon</div>
                  <div class="info-banner-desc">
                    We're building a full work experience editor. In the meantime, you can update your current company and position from your
                    <router-link to="/profile/update">Edit Profile</router-link> page.
                  </div>
                </div>
              </div>

              <!-- Coming soon illustration area -->
              <div class="coming-soon-area">
                <div class="coming-soon-icon">
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
                </div>
                <p class="coming-soon-text">No experience entries yet.</p>
                <p class="coming-soon-sub">The ability to add and manage your work history is coming soon.</p>
                <button class="btn-outline" disabled>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  Add Experience
                </button>
              </div>
            </div>
          </div>
        </main>

      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/layouts/AppLayout.vue';
import axios from 'axios';

export default {
  name: 'Experience',
  components: { AppLayout },

  data() {
    return {
      imgUrl: process.env.VUE_APP_IMAGE_URL || '',
      company: {},
      user: {},
      country: [],
      state: [],
      city: [],
      loading: false,
    };
  },

  created() {
    this.fetchCompany();
    this.fetchUser();
    this.fetchCountries();
  },

  methods: {
    logout() {
      localStorage.clear();
      this.$router.push({ name: 'Login' });
    },

    fetchCompany() {
      axios(process.env.VUE_APP_API_URL + 'company')
        .then(res => { if (res.status === 200) this.company = res.data; })
        .catch(() => {});
    },

    fetchUser() {
      axios(process.env.VUE_APP_API_URL + 'user/details/' + localStorage.getItem('user'))
        .then(res => { if (res.status === 200) this.user = res.data; })
        .catch(() => {});
    },

    fetchCountries() {
      axios(process.env.VUE_APP_API_URL + 'country')
        .then(res => { if (res.status === 200) this.country = res.data; })
        .catch(() => {});
    },

    fetchStates(e) {
      axios(process.env.VUE_APP_API_URL + 'state/' + e.target.value)
        .then(res => { if (res.status === 200) this.state = res.data; })
        .catch(() => {});
    },

    fetchCities(e) {
      axios(process.env.VUE_APP_API_URL + 'city/' + e.target.value)
        .then(res => { if (res.status === 200) this.city = res.data; })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.page-wrap {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 1.5rem;
  padding: 2.5rem 0;
}

/* ── Sidebar ── */
.page-sidebar {
  position: sticky;
  top: 80px;
  align-self: start;
}

.sidebar-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.sidebar-profile {
  padding: 1.5rem 1rem;
  text-align: center;
  border-bottom: 1px solid var(--border);
}

.sidebar-avatar {
  width: 80px;
  height: 80px;
  border-radius: var(--radius-full);
  object-fit: cover;
  border: 3px solid var(--border);
}

.sidebar-name {
  margin-top: 0.75rem;
  font-weight: 700;
  color: var(--text);
  font-size: 0.95rem;
}

.sidebar-sub {
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.sidebar-nav {
  padding: 0.5rem 0;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.65rem 1.25rem;
  font-size: 0.875rem;
  color: var(--text-muted);
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
}

.sidebar-link:hover,
.sidebar-link.active {
  background: var(--surface-2);
  color: var(--primary);
}

.sidebar-link.active {
  font-weight: 600;
  border-right: 3px solid var(--accent);
}

.sidebar-link svg {
  flex-shrink: 0;
}

/* ── Main card ── */
.page-main {
  min-width: 0;
}

.main-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.main-card-header {
  padding: 1.5rem 1.75rem;
  border-bottom: 1px solid var(--border);
}

.main-card-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
  margin: 0 0 0.25rem;
}

.main-card-subtitle {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin: 0;
}

.main-card-body {
  padding: 1.75rem;
}

/* ── Info banner ── */
.info-banner {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: var(--radius);
  padding: 1rem 1.25rem;
  margin-bottom: 2rem;
}

.info-banner-icon {
  color: #3b82f6;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.info-banner-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 0.3rem;
}

.info-banner-desc {
  font-size: 0.82rem;
  color: #1e3a8a;
  line-height: 1.5;
}

.info-banner-desc a {
  color: #2563eb;
  text-decoration: underline;
}

/* ── Coming soon area ── */
.coming-soon-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  color: var(--text-muted);
}

.coming-soon-icon {
  color: var(--border);
  margin-bottom: 1.25rem;
}

.coming-soon-text {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
  margin: 0 0 0.4rem;
}

.coming-soon-sub {
  font-size: 0.85rem;
  color: var(--text-muted);
  max-width: 340px;
  line-height: 1.5;
  margin: 0 0 1.5rem;
}

button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .page-wrap {
    grid-template-columns: 1fr;
    padding: 1.5rem 0;
  }

  .page-sidebar {
    position: static;
  }

  .sidebar-nav {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    padding: 0.5rem;
  }

  .sidebar-link {
    padding: 0.5rem 0.75rem;
    border-radius: var(--radius);
    font-size: 0.8rem;
  }

  .sidebar-link.active {
    border-right: none;
    background: var(--surface-3);
  }
}
</style>
